import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import {
  transformVirtualTenantRecord,
  VirtualTenantForm,
} from "./VirtualTenantForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface IVirtualTenantCreateProps {}

export const VirtualTenantCreate = (props: IVirtualTenantCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      transform={transformVirtualTenantRecord}
      title="Create a virtual customer"
    >
      <VirtualTenantForm />
    </Create>
  );
};
